import React from 'react';
import styled from '@benzinga/themetron';
// import { SimpleAccount } from './SimpleAccount';

export const SimpleHeaderBar: React.FC = () => {
  return (
    <SimpleHeaderBarWrapper className="px-5 flex items-center justify-end">
      {/* <SimpleAccount /> */}
    </SimpleHeaderBarWrapper>
  );
};

const SimpleHeaderBarWrapper = styled.div`
  background-color: #093451;
  min-height: 40px;
  color: #fff;
`;
